import type { WorkItemEnhanced } from "../../types/cqa";
import { WorkItemDataEntry } from "../../types/sd";
import { getCqaGraderWorkitemsBatch } from "../api";

export async function cqaTransformWorkItems(workItems: WorkItemDataEntry[]): Promise<WorkItemEnhanced[]> {
    if(workItems.length == 0){
        return [];
    }

    const sdCaseIds = workItems.map((wi) => wi.data.case_id);
    const cqaGraderWorkItems = await getCqaGraderWorkitemsBatch(sdCaseIds);

    return workItems.map(workitem => ({
        ...workitem, 
        data: {
            ...workitem.data,
            cqa_invoices: cqaGraderWorkItems.find((grader) => grader.sdCaseId === workitem.data.case_id)?.invoices || [],
        }
    }));
}